import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
];

const Register = () => {
  const [searchParams] = useSearchParams();
  const referByFromParams = searchParams.get("REFERBY");

  // Get REFERBY from params or localStorage
  const REFERBY = referByFromParams || localStorage.getItem("REFERBY") || "";

  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [errorText, setErrorText] = useState(false);
  const [fullName, setFullName] = useState("");
  const [error, setError] = useState({
    phone: false,
    email: false,
    fullName: false,
  });
  const navigate = useNavigate();

  // Store REFERBY in localStorage when it exists in params
  useEffect(() => {
    if (referByFromParams) {
      localStorage.setItem("REFERBY", referByFromParams);
    }
  }, [referByFromParams]);

  // Store UTM params & fbclid in localStorage when present in URL
  useEffect(() => {
    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key);
      if (value) {
        localStorage.setItem(key, value);
      }
    });
  }, [searchParams]);

  useEffect(() => {
    localStorage.setItem("user-email", email);
  }, [email]);
  const logApiCalls = (logs) => {
    axios.post(`${process.env.REACT_APP_BE_BASE_URL}api-log/save`, { logs }).catch(err => {
      console.error("Failed to save api logs:", err);
    });
  };

  const sendFirstStepData = () => {
    setErrorText(false);
    const formattedPhone = process.env.REACT_APP_COUNTRY_CODE === "+972"
      ? `+972${phoneNumber
          .replace(/^\+972/, "")
          .replace(/^0/, "")
          .replaceAll("-", "")
          .trim()}`
      : `+91${phoneNumber.replace(/^\+91/, "").replace(/^0/, "").replaceAll("-", "").trim()}`;

    axios
      .post(`${process.env.REACT_APP_BE_BASE_URL}user/register?step=1`, {
        full_name: fullName,
        ...(REFERBY && { REFERBY }),
        email: email,
        phone_number: formattedPhone,
      })
      .then((res) => {
        toast.success(`OTP sent to ${phoneNumber} successfully!`);
        sendDataToHook();
        sendDataToSalesforce(formattedPhone);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "lead_form_submit",
          form_name: "register_step_1_lead_form",
          form_id: `register_step_1_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
          page_url: window.location.href,
        });
        console.log("GTM lead_form_submit event fired for register step 1");
        // Log not called APIs from Register.js
        logApiCalls([
          {
            email,
            full_name: fullName,
            phone_number: formattedPhone,
            page: "Register",
            registration_step: "step_1",
            api_name: "get_insurance",
            api_url: "https://f3fxrg0gd3.execute-api.eu-central-1.amazonaws.com/get_insurance",
            was_called: false,
            skip_reason: "not_applicable_on_register_page",
            request_payload: null,
            response_status: null,
            response_settled: null,
            error_message: null
          },
          {
            email,
            full_name: fullName,
            phone_number: formattedPhone,
            page: "Register",
            registration_step: "step_1",
            api_name: "get_pension",
            api_url: "https://zco3myjcyc.execute-api.eu-central-1.amazonaws.com/get_pension",
            was_called: false,
            skip_reason: "not_applicable_on_register_page",
            request_payload: null,
            response_status: null,
            response_settled: null,
            error_message: null
          }
        ]);
        navigate("/otp?from=register", {
          state: { phoneNumber, email, fullName },
        });
      })
      .catch((err) => {
        // Log webhook not called because step 1 registration failed
        logApiCalls([
          {
            email,
            full_name: fullName,
            phone_number: formattedPhone,
            page: "Register",
            registration_step: "step_1",
            api_name: "make_webhook",
            api_url: "https://hook.eu1.make.com/hxk22yyj8th3neeg47m9vzqw60e8pi93",
            was_called: false,
            skip_reason: `registration_step1_failed: ${err?.message || "Unknown error"}`,
            request_payload: {
              fullName: fullName,
              email: email,
              phone_number: phoneNumber,
              ...getUtmData(),
            },
            response_status: err?.status || null,
            response_settled: "rejected",
            error_message: err?.message || null
          },
          {
            email,
            full_name: fullName,
            phone_number: formattedPhone,
            page: "Register",
            registration_step: "step_1",
            api_name: "get_insurance",
            api_url: "https://f3fxrg0gd3.execute-api.eu-central-1.amazonaws.com/get_insurance",
            was_called: false,
            skip_reason: "not_applicable_on_register_page",
            request_payload: null,
            response_status: null,
            response_settled: null,
            error_message: null
          },
          {
            email,
            full_name: fullName,
            phone_number: formattedPhone,
            page: "Register",
            registration_step: "step_1",
            api_name: "get_pension",
            api_url: "https://zco3myjcyc.execute-api.eu-central-1.amazonaws.com/get_pension",
            was_called: false,
            skip_reason: "not_applicable_on_register_page",
            request_payload: null,
            response_status: null,
            response_settled: null,
            error_message: null
          }
        ]);

        if (err && err.status === 409) {
          Swal.fire({
            title: "האימייל או הטלפון כבר קיימים?",
            text: "האימייל שהוזן כבר קיים, אנא התחבר או הירשם עם פרטים אחרים!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "התחברות",
            confirmButtonColor: "#1B7870",
            cancelButtonText: "להישאר בהרשמה",
            cancelButtonColor: "f6f6f6",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/login");
            }
          });
        } else {
          toast.error(
            `Unable to send OTP to ${phoneNumber}, please check the data correctly!`,
          );
        }
        setErrorText(true);
        console.error("Error sending data", err);
      });
  };
  const getUtmData = () => {
    const data = {};
    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key) || localStorage.getItem(key) || "";
      if (value) data[key] = value;
    });
    return data;
  };

  const sendDataToHook = () => {
    const commonPayload = {
      fullName: fullName,
      email: email,
      phone_number: phoneNumber,
      ...getUtmData(),
    };
    axios.post(
      "https://hook.eu1.make.com/hxk22yyj8th3neeg47m9vzqw60e8pi93",
      commonPayload,
    ).then((res) => {
      logApiCalls([
        {
          email,
          full_name: fullName,
          phone_number: phoneNumber,
          page: "Register",
          registration_step: "step_1",
          api_name: "make_webhook",
          api_url: "https://hook.eu1.make.com/hxk22yyj8th3neeg47m9vzqw60e8pi93",
          was_called: true,
          skip_reason: null,
          request_payload: commonPayload,
          response_status: res.status,
          response_settled: "fulfilled",
          response_data: res.data || null,
          error_message: null
        }
      ]);
    }).catch((err) => {
      logApiCalls([
        {
          email,
          full_name: fullName,
          phone_number: phoneNumber,
          page: "Register",
          registration_step: "step_1",
          api_name: "make_webhook",
          api_url: "https://hook.eu1.make.com/hxk22yyj8th3neeg47m9vzqw60e8pi93",
          was_called: true,
          skip_reason: null,
          request_payload: commonPayload,
          response_status: err?.status || null,
          response_settled: "rejected",
          response_data: err?.response?.data || null,
          error_message: err?.message || null
        }
      ]);
    });
  };

  const sendDataToSalesforce = (formattedPhone) => {
    const sfUrl = `${process.env.REACT_APP_BE_BASE_URL}salesforce/lead`;
    const nameParts = (fullName || "").trim().split(/\s+/);
    const payload = {
      ProFin__First_Name__c: nameParts.slice(0, -1).join(" ") || nameParts[0] || "",
      ProFin__Last_Name__c: nameParts.length > 1 ? nameParts[nameParts.length - 1] : nameParts[0] || "",
      ProFin__Email__c: email,
      ProFin__Mobile_Phone__c: formattedPhone,
      ProFin__Status__c: "First Step Completed",
      ProFin__Source__c: "Web",
      Source_App__c: "Web App",
    };
    const sfRecordId = localStorage.getItem(`sf_lead_id_${email}`);
    if (sfRecordId) payload._sfRecordId = sfRecordId;
    axios.post(sfUrl, payload).then((res) => {
      if (res.data?.id) localStorage.setItem(`sf_lead_id_${email}`, res.data.id);
      console.log("Salesforce Lead API succeeded (Step 1):", res.status, res.data);
      logApiCalls([{
        email,
        full_name: fullName,
        phone_number: formattedPhone,
        page: "Register",
        registration_step: "step_1",
        api_name: "salesforce_lead_direct",
        api_url: sfUrl,
        was_called: true,
        skip_reason: null,
        request_payload: payload,
        response_status: res.status,
        response_settled: "fulfilled",
        response_data: res.data || null,
        error_message: null,
      }]);
    }).catch((err) => {
      console.error("Salesforce Lead API failed (Step 1):", err?.status, err?.message);
      logApiCalls([{
        email,
        full_name: fullName,
        phone_number: formattedPhone,
        page: "Register",
        registration_step: "step_1",
        api_name: "salesforce_lead_direct",
        api_url: sfUrl,
        was_called: true,
        skip_reason: null,
        request_payload: payload,
        response_status: err?.status || null,
        response_settled: "rejected",
        response_data: err?.response?.data || null,
        error_message: err?.message || null,
      }]);
    });
  };

  const validateForm = () => {
    const newError = {
      phone: !phoneNumber.trim(),
      email: !email.trim() || !/\S+@\S+\.\S+/.test(email),
      fullName: !fullName.trim(),
    };

    setError(newError);

    if (newError.phone || newError.email || newError.fullName) {
      return;
    }

    sendFirstStepData();
  };

  return (
    <div className="form_reg">
      <h2 className="box_head mb_2">היכרות והרשמה</h2>
      <h6 className="box_head_h6">
        כמו בכל קשר חדש, קודם כל נלמד להכיר אותך טוב יותר כדי שנוכל לצאת לדרך
        חדשה ולתת לך את הכלים לקבל שליטה טובה יותר על המוצרים הפיננסים שלך.
      </h6>

      <p className="log_label">שם מלא</p>
      <TextField
        type="text"
        size={window.innerWidth < 767 ? "small" : "medium"}
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        error={error.fullName}
        helperText={error.fullName ? "נא להזין שם מלא." : ""}
        InputProps={{
          sx: { borderRadius: window.innerWidth > 767 ? 3 : 1 },
        }}
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: "#1b7870",
            },
          },
          "& .MuiFormHelperText-root": {
            color: "#fc4747 !important",
            textAlign: "right",
            fontWeight: 500,
            marginRight: "0px",
          },
        }}
        id="outlined-basic"
        placeholder="הזן את שמך המלא"
        variant="outlined"
        autoComplete="name" // Explicitly set autocomplete for full name
      />

      <p className="log_label">כתובת דוא"ל</p>
      <TextField
        type="email"
        size={window.innerWidth < 767 ? "small" : "medium"}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={error.email}
        helperText={error.email ? "נא להזין כתובת אימייל חוקית." : ""}
        InputProps={{
          sx: { borderRadius: window.innerWidth > 767 ? 3 : 1 },
        }}
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: "#1b7870",
            },
          },
          "& .MuiFormHelperText-root": {
            color: "#fc4747 !important",
            textAlign: "right",
            fontWeight: 500,
            marginRight: "0px",
          },
        }}
        id="outlined-basic"
        placeholder='הזן את כתובת הדוא"ל שלך'
        variant="outlined"
        autoComplete="email" // Explicitly set autocomplete for email
      />

      <p className="log_label">מספר טלפון</p>
      <TextField
        type="tel"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        error={error.phone}
        helperText={error.phone ? "נא להזין מספר טלפון חוקי." : ""}
        size={window.innerWidth < 767 ? "small" : "medium"}
        InputProps={
          {
            // startAdornment: (
            //   <InputAdornment style={{ color: 'black', fontWeight: 500 }} position="start">
            //     <span className='pre-num'>972+</span>
            //   </InputAdornment>
            // ),
          }
        }
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            borderRadius: window.innerWidth < 767 ? "5px" : "10px",
            "&:hover fieldset": {
              borderColor: "#1b7870",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1b7870",
            },
            "&.Mui-error fieldset": {
              borderColor: "#fc4747",
            },
          },
          "& .MuiFormHelperText-root": {
            color: "#fc4747 !important",
            textAlign: "right",
            fontWeight: 500,
            marginRight: "0px",
          },
        }}
        id="outlined-basic"
        placeholder="הזן את מספר הטלפון שלך"
        variant="outlined"
        autoComplete="tel" // Explicitly set autocomplete for phone
      />

      <button className="login_btn" onClick={validateForm}>
        שלחו לי קוד כניסה בSMS
      </button>

      {errorText && (
        <p className="error_text">מידע לא חוקי או משוכפל. אנא בדוק ונסה שוב.</p>
      )}
      {/* <p className='divison'>אוֹ</p> */}
      {/* <div className='wa_div'>
        <img className='wa_icon' src={whatsappIcon} alt='whatsapp' />
        <p className='wa_text'>שלחו לי קוד כניסה בווואטסאפ</p>
      </div> */}
      <div className="text-center" onClick={() => navigate("/login")}>
        <span className="link_btn">כבר נרשמת? לחץ כאן להתחברות</span>
      </div>
    </div>
  );
};

export default Register;
